import React, { useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useParams } from 'react-router';
import { getDraft, clearCurrentDraft, setDraftId, deleteDraft } from '../../../store/drafts';
import { transformDraftToRide } from '../../../utils/';
import { RideDetails, useDeleteRestoreModal } from '../../../components';
import { BackIcon } from '../../../assets';
import { UberHealthTag } from '../../../components/common/UberHealthTag/UberHealthTag';
import { URLS } from '../../../constants/constants';
import { RideActionsPanel } from '../../../components/common/RideActionsPanel/RideActionsPanel';
import { Navigation } from '../../../utils/navigation';
import styles from './index.module.css';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';

const DraftInfo = ({ setDraftId, getDraft, currentDraft, clearCurrentDraft,  deleteDraft }) => {
  const { id } = useParams();
  const navigate = Navigation();
  const transformedRide = currentDraft ? transformDraftToRide(currentDraft) : null;

  const handleConfirmDeleteDraft = useCallback(
    () => deleteDraft({ draftId: currentDraft?.id, pathname: URLS.DRAFTS,Navigation:navigate }),
    [currentDraft?.id, deleteDraft],
  );
  const { Modal, setDeleteRestoreModalVisible: setDeleteModalVisible } = useDeleteRestoreModal({
    handleConfrim: handleConfirmDeleteDraft,
    title: `Deleting Draft`,
    description: (
      <>
        Are you sure you want to delete this draft (<span className={styles.bold}>ID {currentDraft?.seqId}</span>)?
        <br />
        It will be removed permanently.
      </>
    ),
    confirmActionButtonText: 'Delete Draft',
  });
  useEffect(() => {
    getDraft(id);
    return;
  }, [getDraft, id]);

  useEffect(() => () => clearCurrentDraft(), [clearCurrentDraft]);

  const handleBack = useCallback(() => navigate.back(), [navigate]);

  const handleEditDraft = useCallback(() => {
    setDraftId(id);
    navigate.push(URLS.EDIT_DRAFT,{ from: navigate?.location.pathname });
  }, [navigate, id, setDraftId]);

  const handleDeleteDraft = useCallback(() => setDeleteModalVisible(true), [setDeleteModalVisible]);

  return (
    <div className={styles.pageContent}>
      <div className={styles.header}>
        <div className={styles.backBtn} onClick={handleBack}>
          <BackIcon width='26px' height='26px' fill='#E1F4D3' />
        </div>
        <h1 className={styles.pageTitle}>
          Draft Details - ID {currentDraft?.seqId}
          {transformedRide?.vehicleType === 'uberAmbulatoryRide' && <UberHealthTag />}
        </h1>
      </div>
      <div className={styles.rideDetails}>
        <RideDetails values={transformedRide} showFullInfo />
        <RideActionsPanel
          entities={[
            { id: 0, Icon: EditOutlined, iconProps: { fill: '#6B8F74', stroke: 'white', width: 22, height: 22 }, action: handleEditDraft },
            { id: 1, Icon: DeleteOutlined, iconProps: { mainFill: 'white', accentFill: '#6B8F74', width: 22, height: 22 }, action: handleDeleteDraft },
          ]}
        />
        {Modal}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  currentDraft: state.drafts.draft,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ getDraft, clearCurrentDraft, setDraftId, deleteDraft }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DraftInfo);
